import css from 'styled-jsx/css';

const staticStyles = css.global`
  .SwitchTableVariant {
    &__buttons-wrapper {
      margin-bottom: 8px;
      display: flex;
      justify-content: flex-end;
    }

    &__button {
      padding: 12px;
      background-color: #fff;
      border-color: #e5e5e5;

      svg {
        color: #000;
      }

      &:first-child {
        border-right: none;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      &:last-child {
        border-left: none;

        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .SwitchTableVariant {
      &__button {
        &--active {
          background-color: ${colors.primary.hex};
          border-color: ${colors.primary.hex};

          svg {
            color: #fff;
          }
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
